module.exports = __webpack_public_path__ + "img/exclamation-yellow.17313062.svg";